import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "antd";
import AdminBreadCrumb from "components/AdminBreadCrumb";
import ImportLocations from "modules/client/routes/components/exports";
import WaitingModal from "modules/client/routes/components/WaitingModal";
import "./ImportFilePage.scss";

const ImportFilePage = () => {
  const history = useHistory();
  const [totalStop, setTotalStop] = useState(0);
  const [currentStop, setCurrentStop] = useState(0);
  const [showWaitingModal, setShowWaitingModal] = useState(false);

  const breadCrumbs = [{ text: "IMPORT FILE", url: "/import-file" }];

  const percent = Math.round((currentStop * 100) / totalStop);

  const handleCloseImport = () => {
    setShowWaitingModal(true);
  };

  const handleWaitingModalClose = () => {
    setShowWaitingModal(false);
    // Redirect to routes page after import is complete
    history.push("/routes");
  };

  return (
    <div className="import-file-page">
      <div className="import-file-header my-4">
        <AdminBreadCrumb breadCrumbs={breadCrumbs} />
      </div>

      <div className="import-file-content">
        <ImportLocations
          handleCloseModal={handleCloseImport}
          setCurrentStop={setCurrentStop}
          setTotalStop={setTotalStop}
        />
      </div>

      {showWaitingModal && (
        <Modal
          closable={false}
          visible={true}
          className="no-padding-modal"
          onCancel={handleWaitingModalClose}
          footer={false}
          width={400}
        >
          <WaitingModal percent={percent} />
        </Modal>
      )}
    </div>
  );
};

export default ImportFilePage;
